<template>
    <div class="contact">
        <Menu :color="'orange'"/>
        <b-container class="wrapper">
            <b-row>
                <b-col class="mb-4" md="6">
                    <span class="hightlight-green">Contáctanos</span>
                    <h1 class="mb-3 mt-3">¡Estamos aquí
                        para ayudarte!</h1>
                    <p class="subtext mb-5">Envíanos un mensaje o llámanos, un representante se pondrá en contacto contigo.</p>
                    
                    <p class="footer-info"> <img src="../assets/footer/telefono.png" alt="icon phone"> 686 564 9090</p>
                    <p class="footer-info"> <img src="../assets/footer/ubi.png" alt="icon ubication"> Calle Profesor Charles Piña #657 <br>
                    Col.Rivera, Mexicali, BC, CP 21259</p>
                    <p class="footer-info"> <img src="../assets/footer/correo.png" alt="icon ubication"> <a href="mailto:jesus.ramos.bf@gmail.com">jesus.ramos.bf@gmail.com</a></p>
                    
                    
                    <a href="#" class="privacylink">Aviso de privacidad</a>
                </b-col>
                <b-col md="6">
                    <div class="form text-center">
                        <b-container>
                            <b-row>
                                <b-col>
                                    <div class="form-wrapper">
                                        <p class="mb-5">Llena tus datos, un representante
                                            se pondrá en contacto contigo.</p>
                                        <p class="sendText">{{ messageSend }}</p>
                                        <b-container>
                                            <b-row>
                                                <b-col md="12" class="mb-3 form-floating">
                                                    <b-form-input id="input-1" v-model="name" placeholder="Name*" type="text"></b-form-input>
                                                    <label for="input-1">Nombre</label>
                                                </b-col>
                                                <b-col md="12" class="mb-3 form-floating">
                                                    <b-form-input id="input-3" v-model="phone" placeholder="Phone*" type="text"></b-form-input>
                                                    <label for="input-3">Número de teléfono</label>
                                                </b-col>
                                                <b-col md="12" class="mb-3 form-floating">
                                                    <b-form-input id="input-2" v-model="email" placeholder="Email*" type="text"></b-form-input>
                                                    <label for="input-2">Correo electrónico</label>
                                                </b-col>
                                                <b-col md="12" class="mb-3"> 
                                                    <b-form-textarea id="input-3" v-model="message" placeholder="Mensaje" rows="6" max-rows="3"></b-form-textarea>
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                        
                                        <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
                                        <b-button class="btn btn-clients mt-4" v-on:click="sendMessage">Enviar mensaje</b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </b-col>
            </b-row>
            <b-row class="map">
                <b-col>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d920.1521002516826!2d-115.39814290594238!3d32.65731526115937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d77199eaa2fa7d%3A0xff83ee3b0447f527!2sBe%20Fashion%20Eyewear!5e0!3m2!1ses-419!2smx!4v1724685255718!5m2!1ses-419!2smx" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import Menu from '../components/Menu.vue'
    import axios from 'axios'
    export default {
        name: 'Contact',
        components: {
            Menu
        },
        data() {
            return {
                name: '',
                email: '',
                phone: '',
                message: '',
                pet:'',
                messageSend: ''
            }
        },
        methods: {
            sendMessage: async function(){
                var responseData
                if(this.name != '' && this.email != '' && this.pet == ''){
                    await axios.post('vendor/send-contact.php', {
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        message: this.message
                    })
                    .then((response) => {
                        responseData = response.data
                    })
                    .catch((error) => {
                        /* eslint-disable no-console */
                        console.log(error);
                        /* eslint-enable no-console */
                    });
                    console.log(responseData);
                    if(responseData==200 || responseData=='200') {
                        this.name = ''
                        this.email = ''
                        this.phone = ''
                        this.message = ''
                        this.messageSend = 'Mensaje enviado'
                    } else {
                        this.messageSend = 'Error al enviar mensaje, intenta mas tarde.'
                    }
                } else {
                    this.messageSend = 'Ingresa la información necesaria en los campos.'
                }
            }
        }
    }
</script>

<style scoped>
h1{
    color: #9DF002;
    font-size: 50px;
}
p{
    font-size: 20px;
    color: #fff;
}
.subtext{
    color: #B7EFFF;
    max-width: 500px;
}
.footer-info{
    padding-left: 25px;
    position: relative;
}

.footer-info img{
    position: absolute;
    top: 7px;
    margin-left: -25px;
}

.footer-info a{
    color: #fff;
    text-decoration: none;
}
.contact{
    background: #001824;
}
.wrapper{
    padding-top: 150px;
    padding-bottom: 150px;
}
iframe{
    width: 100%;
}

.hightlight-green{
  font-size: 14px;
  background: #FFFFFF1A;
  border-radius: 10px;
  color: #9DF002;
  padding: 5px 15px;
  margin-bottom: 20px;
}
.privacylink{
    text-decoration: none;
    color: rgba(255,255,255,0.4);
    margin-top: 20px;
}



/* FORM */

.form-wrapper{
    background: #16B7C2;
    border-radius: 20px;
    padding: 45px 50px 60px 50px;
    color: #000;
}
.form-wrapper p{
    color: #000;
}
/* FORM */
.btn-clients{
    width: 100%; 
    color: #fff !important;
    font-size: 25px;
    background: #FC5300 !important;
    border: none;
    padding: 10px;
    max-width: 285px;
}

.form-floating > .form-control{
    background: #fff;
    border: none;
    border-radius: 5px;
    color: #000;
    font-size: 18px;
    outline: none !important;
    padding-left: 20px;
}

.form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {
    color: rgba(0,0,0, 0.4) !important; 
    -webkit-transform: scale(0.65) translateY(-0.5rem) translateX(0rem);
    transform: scale(0.65) translateY(-0.5rem) translateX(0rem);
    left: 20px;
}

label{
    color: #000;
    font-size: 18px;
}
textarea{
    background: #fff;
    border-radius: 5px;
    border: none;
    outline: none;
    font-size: 18px;
    color: #000;
    padding-left: 20px;
}
input:focus,
input:active{
    outline: none !important;
    box-shadow: none !important;
}
.form-floating label{
    font-size: 18px;
    color: #000 !important;
    padding-left: 20px;
    left: 10px;
}
.form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after{
    background: transparent;
    color: #000 !important;
}
.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}
.sendText{
    font-size: 16px;
    font-weight: 700;
}


/* MAP */
.map{
    margin-top: 100px;
}
iframe{
    border-radius: 20px;
}

@media (max-width: 768px){
    h1{
        font-size: 40px;
    }
    p{
        font-size: 18px;
    }
    .footer-info{
        padding-left: 25px;
        position: relative;
    }

    .footer-info img{
        position: absolute;
        top: 7px;
        margin-left: -25px;
    }

    .footer-info a{
        color: #fff;
        text-decoration: none;
    }
    .contact{
        background: #132A51;
    }
    .wrapper{
        padding: 100px 7%;
    }
    iframe{
        width: 100%;
    }
    /* FORM */
    .form-wrapper{
        padding: 45px 7% 60px 7%;
        color: #000;
    }
    .btn-clients{
        font-size: 20px;
    }

}
</style>